import {Layout} from "@components";
import React, {useEffect} from "react";
import styles from "./style.module.scss";
import {useSearchParams} from "react-router-dom";
import {useLogin, useNav} from "@hook";
import {ScreenId} from "@assets";

export default function Page() {
  const {navigate} = useNav();
  const {login} = useLogin();
  const [searchParams] = useSearchParams();

  async function loginProc(code: string) {
    const result = await login(code);
    if (result.success) {
      navigate({url: ScreenId.HOME});
    } else {
      alert(result.message || "로그인에 실패하였습니다.");
      navigate({url: ScreenId.LOGIN});
    }
  }

  useEffect(() => {
    const code = searchParams.get("code");

    if (!code) return;

    loginProc(code);
  }, [searchParams]);

  return (
    <Layout>
      <div className={styles.container}>로그인 처리중입니다.</div>
    </Layout>
  );
}
